import "./Quiz.scss";
import AppHeader from "../../components/layout/app-header";
import AppBreadcrumb from "../../components/app-breadcrumb";
import Question from "./Question";
import Options from "./QuestionOption";
import { Layout, UnderConstruction } from "../../components";
// Define types
type QuestionType =
  | SpeakAndSelectLessonQuestion
  | FillTheGapQuestion
  | TapWhatYouHearQuestion
  | CrossWordMatchQuestion
  | SingleWordMatchQuestion
  | VideoContentQuestion;

export interface VideoContentQuestion {
  instruction: string;
  question: {
    videoUrl: string;
  };
  activityType: "VideoContentActivity";
  options: VideoContentOption[];
  answer: string;
}

interface VideoContentOption {
  id: string;
  text: string;
  audioUrl?: string;
}

export interface SpeakAndSelectLessonQuestion {
  instruction: string;
  question: {
    audioUrl: string;
  };
  activityType: "SelectCorrectImageActivity";
  options: SpeakAndSelectLessonOption[];
  answer: string;
}

interface SpeakAndSelectLessonOption {
  id: string;
  imageUrl: string;
  text?: string;
  audioUrl?: string;
}

export interface FillTheGapQuestion {
  instruction: string;
  activityType: "FillTheGapActivity";
  imageUrl?: string;
  audioUrl?: string;
  question: string;
  options: FillTheGapLessonOption[];
  answer: string[];
}

interface FillTheGapLessonOption {
  id: string;
  text: string;
  audioUrl: string;
}

export interface TapWhatYouHearQuestion {
  instruction: string;
  activityType: "TapInWhatYouHear";
  question: {
    audioUrl: string;
    text?: string;
  };
  options: TapWhatYouHearOption[];
  answer: string[];
}

interface TapWhatYouHearOption {
  id: string;
  text: string;
  audioUrl: string;
}
type CrossWordAQuestion = { text?: string; audioUrl?: string } & (
  | { text: string }
  | { audioUrl: string }
);
export interface CrossWordMatchQuestion {
  instruction: string;
  activityType: "CrossWordActivity";
  question: CrossWordAQuestion[]; //{ text: string }[];
  options: CrossWordMatchOption[];
  answer: string[];
}

export interface CrossWordMatchOption {
  id: string;
  text: string;
  audioUrl?: string;
}

export interface SingleWordMatchQuestion {
  instruction: string;
  activityType: "MatchTheCorrectWord";
  question: SingleWordMatchQuestionQuestion;
  options: SingleWordMatchOption[];
  answer: string[];
}

export interface SingleWordMatchQuestionQuestion {
  text?: string;
  audioUrl?: string;
}
interface SingleWordMatchOption {
  id: string;
  text: string;
  audioUrl?: string;
  imageUrl?: string;
}

const quizData: QuestionType[] = [
  {
    activityType: "MatchTheCorrectWord",
    instruction: "Select the right word",
    question: {
      audioUrl: "https://lams-assets.s3.us-east-1.amazonaws.com/audio/000C.mp3",
    },
    answer: ["0040"],
    options: [
      {
        id: "0040",
        audioUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/audio/000C.mp3",
        text: "Nwoke",
      },
      {
        id: "0041",
        audioUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/audio/1001.m4a",
        text: "Nwaanyị",
      },
      {
        id: "0042",
        audioUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/audio/0003.mp3",
        text: "Nwata Nwoke",
      },
      {
        id: "0043",
        imageUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/graphics/0004.png",
        audioUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/audio/100F.m4a",
        text: "Nwata nwaanyị",
      },
      {
        id: "0043",
        imageUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/graphics/0004.png",
        audioUrl:
          "https://lams-assets.s3.us-east-1.amazonaws.com/audio/100F.m4a",
        text: "Nwata nwaanyị",
      },
    ],
  },
];

const ListQuestion = () => {
  // use more semantic meaning later on.
  return (
    // <section>
    //   <AppHeader />
    //   <AppBreadcrumb />
    //   <main>
    //     <section className="container">
    //       <div className="quiz-container">
    //         {quizData.map((question, index) => (
    //           <div
    //             key={index}
    //             className={`question-card ${question.activityType}`}
    //           >
    //             <div className="meta-data">
    //               <div className="lesson-category">
    //                 {question.instruction} *
    //               </div>
    //               <div className="language-tag">Lesson Id: 0001 </div>
    //               <div className="language-tag">Something Else</div>
    //             </div>
    //             <div className="question-data">
    //               <Question
    //                 image="https://lams-assets.s3.us-east-1.amazonaws.com/graphics/0004.png"
    //                 audio="https://lams-assets.s3.us-east-1.amazonaws.com/audio/0003.mp3"
    //                 text="Nwoke"
    //               />
    //             </div>

    //             <div className="options">
    //               {question.options.map((option, i) => (
    //                 <Options
    //                   key={i}
    //                   image="https://lams-assets.s3.us-east-1.amazonaws.com/graphics/0004.png"
    //                   audio="https://lams-assets.s3.us-east-1.amazonaws.com/audio/0003.mp3"
    //                   text="Nwoke"
    //                 />
    //               ))}
    //             </div>

    //             <div className="answers">List all the correct options here</div>
    //           </div>
    //         ))}
    //       </div>
    //     </section>
    //   </main>
    // </section>

    <Layout>
      <UnderConstruction />
    </Layout>
  );
};

export default ListQuestion;
